import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/zora.peteri/projects/react-tweet-card/node_modules/gatsby-theme-docz/src/base/Layout.js";
import TweetCard from './TweetCard';
import ThemeHandler from './ThemeHandler';
import Container from './components/Container';
import { Playground } from 'docz';
import { Code } from 'gatsby-theme-docz/src/components/Code';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <ThemeHandler mdxType="ThemeHandler" />
    <h2 {...{
      "id": "installation"
    }}>{`Installation`}</h2>
    <Code className="bash" mdxType="Code">
    {`npm i react-tweet-card
# or
yarn add react-tweet-card`}
    </Code>
    <h2 {...{
      "id": "basic-setup"
    }}>{`Basic setup`}</h2>
    <p>{`Here's how to set up a tweet card with basic information:`}</p>
    <Playground __position={2} __code={'<Container>\n  <TweetCard\n    author={{\n      name: \'randy\',\n      username: \'randyfactory\',\n      image:\n        \'https://pbs.twimg.com/profile_images/1382083582752096262/xrx0PO8Z_400x400.jpg\',\n    }}\n    tweet={`how was “philosopher” ever a job lmao like was socrates sippin wine on a balcony somewhere drunkenly slurring shit like “to find urself, think for urself” with a crowd cheering underneath him like fuck yes socrates another banger this man will not miss`}\n    time={new Date(2021, 2, 2, 21, 3)}\n    source=\"Twitter for iPhone\"\n    permalink=\"https://twitter.com/randyfactory/status/1366841622495961091\" // optional\n    fitInsideContainer\n  />\n</Container>'} __scope={{
      props,
      DefaultLayout,
      TweetCard,
      ThemeHandler,
      Container,
      Playground,
      Code,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <Container mdxType="Container">
        <TweetCard author={{
          name: 'randy',
          username: 'randyfactory',
          image: 'https://pbs.twimg.com/profile_images/1382083582752096262/xrx0PO8Z_400x400.jpg'
        }} tweet={`how was “philosopher” ever a job lmao like was socrates sippin wine on a balcony somewhere drunkenly slurring shit like “to find urself, think for urself” with a crowd cheering underneath him like fuck yes socrates another banger this man will not miss`} time={new Date(2021, 2, 2, 21, 3)} source="Twitter for iPhone" permalink="https://twitter.com/randyfactory/status/1366841622495961091" // optional
        fitInsideContainer mdxType="TweetCard" />
    </Container>
    </Playground>
    <h2 {...{
      "id": "tweet-author-options"
    }}>{`Tweet author options`}</h2>
    <p>{`You can specify that the author of the tweet you're displaying in the card is either verified or protected (private).
The verified badge will show next to the user's name for verified users, and the padlock icon for protected users.
To add these properties, add `}<inlineCode parentName="p">{`isVerified: true`}</inlineCode>{` or `}<inlineCode parentName="p">{`isProtected: true`}</inlineCode>{` to the `}<inlineCode parentName="p">{`author`}</inlineCode>{` prop.
You can also use `}<inlineCode parentName="p">{`isGovernment`}</inlineCode>{` or `}<inlineCode parentName="p">{`isBusiness`}</inlineCode>{` alongside `}<inlineCode parentName="p">{`isVerified`}</inlineCode>{`.`}</p>
    <Playground __position={3} __code={'<Container>\n  <TweetCard\n    author={{\n      name: \'hatsune mitski (zeph)\',\n      username: \'zephanijong\',\n      image:\n        \'https://pbs.twimg.com/profile_images/1605512789107286016/keR9YPE2_400x400.jpg\',\n      isVerified: true, // try replacing this with \"isProtected\"\n    }}\n    tweet={`if she\'s your girl why does she follow me on spotify`}\n    time={new Date(2022, 9, 10, 0, 52)}\n    source=\"Twitter for iPhone\"\n    permalink=\"https://twitter.com/zephanijong/status/1579243456869781505\"\n    fitInsideContainer\n  />\n</Container>'} __scope={{
      props,
      DefaultLayout,
      TweetCard,
      ThemeHandler,
      Container,
      Playground,
      Code,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <Container mdxType="Container">
        <TweetCard author={{
          name: 'hatsune mitski (zeph)',
          username: 'zephanijong',
          image: 'https://pbs.twimg.com/profile_images/1605512789107286016/keR9YPE2_400x400.jpg',
          isVerified: true // try replacing this with "isProtected" 

        }} tweet={`if she's your girl why does she follow me on spotify`} time={new Date(2022, 9, 10, 0, 52)} source="Twitter for iPhone" permalink="https://twitter.com/zephanijong/status/1579243456869781505" fitInsideContainer mdxType="TweetCard" />
    </Container>
    </Playground>
    <h2 {...{
      "id": "adding-images"
    }}>{`Adding images`}</h2>
    <p>{`You can add images to a tweet by using the `}<inlineCode parentName="p">{`tweetImages`}</inlineCode>{` prop. You have to pass in an array of objects that have a `}<inlineCode parentName="p">{`src`}</inlineCode>{` property with the URL to your images.
You can also add an `}<inlineCode parentName="p">{`isVideoThumbnail`}</inlineCode>{` property set to `}<inlineCode parentName="p">{`true`}</inlineCode>{`, which does exactly what you would think. A maximum of 4 images is allowed within a tweet.`}</p>
    <p>{`Note: The `}<inlineCode parentName="p">{`fitInsideContainer`}</inlineCode>{` prop makes the card fill out its parent container, so when you're dynamically changing the content of your tweet, make sure to allocate
enough visual space for the images, and pay attention the aspect ratio of the container. `}</p>
    <Playground __position={4} __code={'<Container>\n  <TweetCard\n    author={{\n      name: \'demi adejuyigbe\',\n      username: \'electrolemon\',\n      isVerified: true,\n    }}\n    tweet={`4 months ago i quietly left 57 dvds of \'click\' at my parents\' house and they\'ve still never noticed or mentioned it`}\n    tweetImages={[\n      { src: \'https://pbs.twimg.com/media/BaMEhYBCAAAi6m-?format=jpg\' },\n      { src: \'https://pbs.twimg.com/media/BaMEhYBCAAAi6m-?format=jpg\' },\n      {\n        src: \'https://pbs.twimg.com/media/BaMEhYBCAAAi6m-?format=jpg\',\n        isVideoThumbnail: true,\n      },\n    ]}\n    time={new Date(2022, 10, 28, 22, 30)}\n    permalink=\"https://twitter.com/electrolemon/status/406173363174785024\"\n    fitInsideContainer\n  />\n</Container>'} __scope={{
      props,
      DefaultLayout,
      TweetCard,
      ThemeHandler,
      Container,
      Playground,
      Code,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <Container mdxType="Container">
        <TweetCard author={{
          name: 'demi adejuyigbe',
          username: 'electrolemon',
          isVerified: true
        }} tweet={`4 months ago i quietly left 57 dvds of 'click' at my parents' house and they've still never noticed or mentioned it`} tweetImages={[{
          src: 'https://pbs.twimg.com/media/BaMEhYBCAAAi6m-?format=jpg'
        }, {
          src: 'https://pbs.twimg.com/media/BaMEhYBCAAAi6m-?format=jpg'
        }, {
          src: 'https://pbs.twimg.com/media/BaMEhYBCAAAi6m-?format=jpg',
          isVideoThumbnail: true
        }]} time={new Date(2022, 10, 28, 22, 30)} permalink="https://twitter.com/electrolemon/status/406173363174785024" fitInsideContainer mdxType="TweetCard" />
    </Container>
    </Playground>
    <h2 {...{
      "id": "displaying-engagement"
    }}>{`Displaying engagement`}</h2>
    <p>{`You can use the `}<inlineCode parentName="p">{`engagements`}</inlineCode>{` prop on the component to display the number of replies, retweets and likes a tweet has received.
The layout can look a bit overwhelming when both the tweet's details (time and source) and the engagements are displayed, so you can use the `}<inlineCode parentName="p">{`showDetails`}</inlineCode>{` and `}<inlineCode parentName="p">{`showEngagement`}</inlineCode>{` props to control the layout.
Both props are set to `}<inlineCode parentName="p">{`true`}</inlineCode>{` by default.`}</p>
    <h3 {...{
      "id": "using-emojis"
    }}>{`Using emojis`}</h3>
    <p>{`Setting the `}<inlineCode parentName="p">{`emojis`}</inlineCode>{` prop to `}<inlineCode parentName="p">{`true`}</inlineCode>{` will make the component use emoji characters for the engagement visuals instead of the icons used by Twitter.`}</p>
    <Playground __position={5} __code={'<Container>\n  <TweetCard\n    engagement={{\n      replies: 206,\n      retweets: 17600,\n      likes: 128200,\n    }}\n    emojis={false} // try setting this to true 👀\n    showDetails={false} // try setting this to true 😬\n    author={{\n      name: \'Ethan Hardy\',\n      username: \'ethanhardy\',\n      image:\n        \'https://pbs.twimg.com/profile_images/1579548555131424775/PgoOLvU7_400x400.jpg\',\n    }}\n    tweet={`You say that it\'s fucked that gingerbread men live in gingerbread houses, but to a gingerbread person, gingerbread is as inscrutable and fundamental as carbon. The people and homes are no more alike than humans are to diamonds. Only we, their gods and creators, can see the horror`}\n    time={new Date(2021, 11, 21, 14, 6)}\n    source=\"Twitter for iPhone\"\n    permalink=\"https://twitter.com/ethanhardy/status/1473278732676837382\"\n    fitInsideContainer\n  />\n</Container>'} __scope={{
      props,
      DefaultLayout,
      TweetCard,
      ThemeHandler,
      Container,
      Playground,
      Code,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <Container mdxType="Container">
        <TweetCard engagement={{
          replies: 206,
          retweets: 17600,
          likes: 128200
        }} emojis={false} // try setting this to true 👀
        showDetails={false} // try setting this to true 😬
        author={{
          name: 'Ethan Hardy',
          username: 'ethanhardy',
          image: 'https://pbs.twimg.com/profile_images/1579548555131424775/PgoOLvU7_400x400.jpg'
        }} tweet={`You say that it's fucked that gingerbread men live in gingerbread houses, but to a gingerbread person, gingerbread is as inscrutable and fundamental as carbon. The people and homes are no more alike than humans are to diamonds. Only we, their gods and creators, can see the horror`} time={new Date(2021, 11, 21, 14, 6)} source="Twitter for iPhone" permalink="https://twitter.com/ethanhardy/status/1473278732676837382" fitInsideContainer mdxType="TweetCard" />
    </Container>
    </Playground>
    <h2 {...{
      "id": "server-side-rendering"
    }}>{`Server-side rendering`}</h2>
    <p>{`React Tweet Card can only be rendered on the client side as it loads its CSS directly into the DOM. To make it work with SSR, try importing the package dynamically.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      